import { UserTypes, VatTypes } from "../../../../constants/user";
import {
  CompanyData,
  ValidCompanyDataErrors,
  ValidCompanyDataHints,
} from "../../../../types/user";
import HintText from "../../../simples/HintText/HintText";
import { Input } from "../../../simples/Input";
import { RadioButton } from "../../../simples/RadioButton";
import { TextWithHintIcon } from "../../../simples/TextWithHintIcon";
import styles from "../UserFields.module.scss";
import { GENERATE_PASSWORD_HINT } from "../../../../constants/hints";

type Props = {
  data: CompanyData;
  setData: (field: keyof CompanyData, value: any) => void;
  errors: ValidCompanyDataErrors | undefined;
  hints?: ValidCompanyDataHints;
  isBeenChange?: boolean;
};

const LeftPartUserFields = ({
  data,
  setData,
  errors,
  hints,
  isBeenChange = true,
}: Props) => {
  const vat22 = data["form-of-organization"] === VatTypes.vat22;
  const ownershipType = data["type-of-ownership"];

  return (
    <div className={styles.topSiteContainer}>
      <TextWithHintIcon classes={{ root: styles.topTitleHint }} title="ИНН" />
      <Input
        error={errors?.inn && errors.inn[0]}
        hint={hints?.inn && hints.inn[0]}
        classes={{ input: styles.input }}
        onChange={setData.bind(null, "inn")}
        value={data.inn}
        mask={"999999999999"}
        placeholder="Введите номер"
        disabled={!isBeenChange}
      />
      <TextWithHintIcon
        classes={{ root: styles.titleHint }}
        title="Форма организации"
      />
      <RadioButton
        isChoosed={vat22}
        title="НДС 22%"
        onClick={
          isBeenChange
            ? setData.bind(null, "form-of-organization", VatTypes.vat22)
            : () => null
        }
      />

      <TextWithHintIcon
        classes={{ root: styles.titleHint }}
        title="Форма собственности"
      />
      {Object.values(UserTypes).map((type, index) => (
        <RadioButton
          key={type}
          classes={index > 0 ? { root: styles.bottomRadio } : undefined}
          isChoosed={ownershipType === type}
          title={type}
          onClick={
            isBeenChange
              ? setData.bind(null, "type-of-ownership", type)
              : () => null
          }
        />
      ))}
      <TextWithHintIcon classes={{ root: styles.title }} title="Телефон*" />
      <Input
        error={errors?.phone && errors.phone[0]}
        classes={{ input: styles.input }}
        onChange={setData.bind(null, "phone")}
        value={data.phone}
        mask={"+7 (999) 999-99-99"}
        disabled={!isBeenChange}
        placeholder={"+7 (___) ___-__-__"}
      />
      <TextWithHintIcon classes={{ root: styles.title }} title="E-mail*" />
      <Input
        error={errors?.email && errors.email[0]}
        classes={{ input: styles.input }}
        onChange={setData.bind(null, "email")}
        value={data.email}
        placeholder="Введите email"
        disabled={!isBeenChange}
      />
      <span className={styles.hint}>
        <HintText mt={24}>{GENERATE_PASSWORD_HINT}</HintText>
      </span>
    </div>
  );
};

export default LeftPartUserFields;
